// OlewinStudioWelcome.jsx
import React, { useState } from 'react';
import { Container, Row, Col, Form, Button,Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles/olewinstudio/studio_welcome.css"; // Import the CSS
// Assuming you have this logo in your images folder
import logo from '../images/olewin.png';

const OlewinStudioWelcome = () => {
  
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [receiveUpdates, setReceiveUpdates] = useState(true); // Pre-checked as in the example
  const [participateResearch, setParticipateResearch] = useState(true); // Pre-checked as in the example

  // Button will only be enabled when terms are accepted
  const isButtonEnabled = acceptTerms;

  const handleContinue = () => {
    console.log('User accepted terms with the following preferences:');
    console.log('Receive updates:', receiveUpdates);
    console.log('Participate in research:', participateResearch);
    // Handle navigation or next steps here
  };

  return ( 
  
  <>
    <div className="olewin-studio-background">
      <Container className="welcome-container">
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={8} lg={6} className="welcome-panel">
            <div className="text-center mb-4">
              <div className="studio-logo ">
                {/* If you want to use a custom logo */}
                <img src={logo} alt="OLEWIN" className="logo1  me-2" style={{ width: '50px', height:'50px' }} />
                
                {/* If you want to use the circle loading animation like in your first example */}
            
              </div>
            </div>
            
            <h2 className="welcome-title">Welcome to Olewin Studio</h2>
            <p className="welcome-description">
              A complete web-based development workspace designed to make it faster
              and easier to build, ship, and manage full-stack, multiplatform
              apps from the comfort of your browser.
            </p>

            <Form className="mt-4">
              <Form.Group className="mb-3" controlId="termsCheckbox">
                <Form.Check 
                  type="checkbox"
                  id="accept-terms"
                  label={
                    <span>
                      I accept the terms and conditions for Olewin Studio Services listed on the{' '}
                      <a href="/" className="terms-link">Terms of Service</a> page and the{' '}
                      <a href="/" className="terms-link">SDK Terms and Conditions</a>
                    </span>
                  }
                  checked={acceptTerms}
                  onChange={(e) => setAcceptTerms(e.target.checked)}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="updatesCheckbox">
                <Form.Check 
                  type="checkbox"
                  id="receive-updates"
                  label="I want to receive email updates about Olewin Studio news and features."
                  checked={receiveUpdates}
                  onChange={(e) => setReceiveUpdates(e.target.checked)}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="researchCheckbox">
                <Form.Check 
                  type="checkbox"
                  id="participate-research"
                  label="I'm interested in participating in research studies to improve Olewin Studio"
                  checked={participateResearch}
                  onChange={(e) => setParticipateResearch(e.target.checked)}
                />
              </Form.Group>

              <div className="text-end mt-4">
                <Button 
                  variant="primary" 
                  className="confirm-button"
                  disabled={!isButtonEnabled}
                  onClick={handleContinue}
                >
                  Confirm
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
<div className="banner-section bg-dark text-white py-5">
      <Container className="text-center py-4">
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            {/* Logo */}
            <div className="text-center mb-4">
              <div className="studio-logo">
                {/* If you want to use a custom logo */}
                <img src={logo} alt="OLEWIN" className="logo1 bg-light me-3" style={{ width: '100px', height:'100px' }} />
                
                {/* If you want to use the circle loading animation like in your first example */}
            
              </div>
            </div>
            
            {/* Main Heading */}
            <h1 className="display-4 fw-bold mb-3">OLEWIN Studio</h1>
            
            {/* Tagline */}
            <p className="lead mb-4">
              From UI/UX to Deploy: Web Apps, Mobile Solutions, Software Development
            </p>
            
            {/* Service Description */}
            <p className="mb-5">
              Complete development cycle with continuous monitoring and regular feature rollouts
            </p>
            
            {/* CTA Button */}
            <Button 
              variant="outline-light" 
              size="lg" 
              className="px-4 py-2 rounded-pill fw-bold"
            >
              Get started
            </Button>
          </Col>
        </Row>
      </Container>

      {/* Services Icons */}
      <Container className="mt-4 mb-3">
        <Row className="justify-content-center text-center g-4">
          <Col xs={6} md={3}>
            <div className="service-icon">
              <i className="bi bi-palette-fill fs-1 mb-2"></i>
              <p>UI/UX Design</p>
            </div>
          </Col>
          <Col xs={6} md={3}>
            <div className="service-icon">
              <i className="bi bi-code-slash fs-1 mb-2"></i>
              <p>Web Development</p>
            </div>
          </Col>
          <Col xs={6} md={3}>
            <div className="service-icon">
              <i className="bi bi-phone fs-1 mb-2"></i>
              <p>Mobile Apps</p>
            </div>
          </Col>
          <Col xs={6} md={3}>
            <div className="service-icon">
              <i className="bi bi-graph-up fs-1 mb-2"></i>
              <p>Monitoring</p>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Custom CSS */}
      <style jsx>{`
        .banner-section {
          background: linear-gradient(145deg, #1a1a1a 0%, #2d2d2d 100%);
          min-height: 80vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        
        .logo-container {
          margin: 0 auto;
          max-width: 80px;
        }
        
        @media (max-width: 768px) {
          .display-4 {
            font-size: 2.2rem;
          }
          .banner-section {
            min-height: 90vh;
          }
        }
      `}</style>
    </div>
    <div className="hosting-features-section py-5" style={{ backgroundColor: '#1a2642' }}>
      <Container>
        {/* Section Title with Icon */}
        <Row className="align-items-center mb-4">
          <Col>
            <div className="d-flex align-items-center">
              <div className="icon-circle me-3">
                <i className="bi bi-display text-dark fs-3"></i>
              </div>
              <h2 className="text-white mb-0 fs-1">Host a web app</h2>
            </div>
          </Col>
          <Col xs="auto">
            <Button variant="outline-light" className="d-flex align-items-center">
              View more <i className="bi bi-box-arrow-up-right ms-2"></i>
            </Button>
          </Col>
        </Row>

        {/* Features Cards */}
        <Row className="g-4">
          {/* Card 1 */}
          <Col md={6}>
            <Card className="bg-transparent text-white border-0 h-100" style={{ backgroundColor: '#1e2d4a' }}>
              <Card.Body className="p-4">
                <h3 className="fs-2 mb-3">Build a secure, realtime, offline-enabled app</h3>
                
                <p className="mb-4">
                  Keep your app's data in sync across clients and even make sure it works regardless of network latency or connectivity. Add authentication and security rules to safeguard that users can only access data they should access.
                </p>
                
                <div className="feature-icons d-flex flex-wrap gap-3 mb-4">
                  <div className="d-flex align-items-center">
                    <div className="feature-icon-circle me-2" style={{ backgroundColor: '#ff9f43' }}>
                      <i className="bi bi-database text-white"></i>
                    </div>
                    <span>Cloud Firestore</span>
                  </div>
                  
                  <div className="d-flex align-items-center">
                    <div className="feature-icon-circle me-2" style={{ backgroundColor: '#ff6b6b' }}>
                      <i className="bi bi-shield-lock text-white"></i>
                    </div>
                    <span>Authentication</span>
                  </div>
                  
                  <div className="d-flex align-items-center">
                    <div className="feature-icon-circle me-2" style={{ backgroundColor: '#ff9f43' }}>
                      <i className="bi bi-hdd-rack text-white"></i>
                    </div>
                    <span>Hosting</span>
                  </div>
                </div>
                
                <div className="d-flex gap-3">
                  <Button variant="outline-light" size="sm">Watch video</Button>
                  <Button variant="outline-light" size="sm">Take guided pathway</Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
          
          {/* Card 2 */}
          <Col md={6}>
            <Card className="bg-transparent text-white border-0 h-100" style={{ backgroundColor: '#1e2d4a' }}>
              <Card.Body className="p-4">
                <h3 className="fs-2 mb-3">Cache data on a global CDN for faster content delivery</h3>
                
                <p className="mb-4">
                  Give your users a faster first-load experience and reduce your querying costs with OLEWIN's global CDN. Use our storage solutions with OLEWIN Hosting to bundle and cache both static and dynamic content.
                </p>
                
                <div className="feature-icons d-flex flex-wrap gap-3 mb-4">
                  <div className="d-flex align-items-center">
                    <div className="feature-icon-circle me-2" style={{ backgroundColor: '#ff9f43' }}>
                      <i className="bi bi-database text-white"></i>
                    </div>
                    <span>Cloud Storage</span>
                  </div>
                  
                  <div className="d-flex align-items-center">
                    <div className="feature-icon-circle me-2" style={{ backgroundColor: '#ff9f43' }}>
                      <i className="bi bi-hdd-rack text-white"></i>
                    </div>
                    <span>Hosting</span>
                  </div>
                  
                  <div className="d-flex align-items-center">
                    <div className="feature-icon-circle me-2" style={{ backgroundColor: '#5352ed' }}>
                      <i className="bi bi-code-square text-white"></i>
                    </div>
                    <span>Cloud Functions</span>
                  </div>
                </div>
                
                <div className="d-flex gap-3">
                  <Button variant="outline-light" size="sm">Try tutorial</Button>
                  <Button variant="outline-light" size="sm">Read blog post</Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Custom CSS */}
      <style jsx>{`
        .hosting-features-section {
          background-color: #1a2642;
        }
        
        .icon-circle {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background-color: #a3c8f8;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .feature-icon-circle {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .card {
          background-color: #1e2d4a !important;
          border-radius: 12px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
        
        @media (max-width: 768px) {
          .feature-icons {
            flex-direction: column;
            gap: 10px;
          }
        }
      `}</style>
    </div>
    <div className="testing-features-section py-5" style={{ backgroundColor: '#1a2642' }}>
      <Container>
        {/* Section Title with Icon */}
        <Row className="align-items-center mb-4">
          <Col>
            <div className="d-flex align-items-center">
              <div className="icon-circle me-3">
                <i className="bi bi-phone-fill text-dark fs-3"></i>
              </div>
              <h2 className="text-white mb-0 fs-1">Test and rollout features</h2>
            </div>
          </Col>
          <Col xs="auto">
            <Button variant="outline-light" className="d-flex align-items-center">
              View more <i className="bi bi-box-arrow-up-right ms-2"></i>
            </Button>
          </Col>
        </Row>

        {/* Features Cards */}
        <Row className="g-4">
          {/* Card 1 */}
          <Col md={6}>
            <Card className="bg-transparent text-white border-0 h-100" style={{ backgroundColor: '#1e2d4a' }}>
              <Card.Body className="p-4">
                <h3 className="fs-2 mb-3">Automate app testing on multiple devices and configurations</h3>
                
                <p className="mb-4">
                  Before distributing to live testers, catch bugs and performance issues by running your mobile app against suites of real, physical test devices hosted by OLEWIN. And even integrate your tests into a CI/CD workflow to automate testing.
                </p>
                
                <div className="feature-icons d-flex flex-wrap gap-3 mb-4">
                  <div className="d-flex align-items-center">
                    <div className="feature-icon-circle me-2" style={{ backgroundColor: '#ffc107' }}>
                      <i className="bi bi-clipboard-check text-dark"></i>
                    </div>
                    <span>Test Lab</span>
                  </div>
                </div>
                
                <div className="d-flex gap-3">
                  <Button variant="outline-light" size="sm">Watch video</Button>
                  <Button variant="outline-light" size="sm">Try codelab</Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
          
          {/* Card 2 */}
          <Col md={6}>
            <Card className="bg-transparent text-white border-0 h-100" style={{ backgroundColor: '#1e2d4a' }}>
              <Card.Body className="p-4">
                <h3 className="fs-2 mb-3">Ensure stable and delightful features before launch</h3>
                
                <p className="mb-4">
                  Get feedback and data from real users that a feature is stable and enjoyable before releasing it to your entire user base. Test different versions of your app and iterate quickly to achieve the best user experience.
                </p>
                
                <div className="feature-icons d-flex flex-wrap gap-3 mb-4">
                  <div className="d-flex align-items-center">
                    <div className="feature-icon-circle me-2" style={{ backgroundColor: '#ffc107' }}>
                      <i className="bi bi-send-check text-dark"></i>
                    </div>
                    <span>App Distribution</span>
                  </div>
                  
                  <div className="d-flex align-items-center">
                    <div className="feature-icon-circle me-2" style={{ backgroundColor: '#ffc107' }}>
                      <i className="bi bi-bug text-dark"></i>
                    </div>
                    <span>Crashlytics</span>
                  </div>
                  
                  <div className="d-flex align-items-center">
                    <div className="feature-icon-circle me-2" style={{ backgroundColor: '#ffc107' }}>
                      <i className="bi bi-gear text-dark"></i>
                    </div>
                    <span>Remote Config</span>
                  </div>
                </div>
                
                <div className="d-flex gap-3">
                  <Button variant="outline-light" size="sm">Watch video</Button>
                  <Button variant="outline-light" size="sm">Try codelab</Button>
                  <Button variant="outline-light" size="sm">Read case study</Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Custom CSS */}
      <style jsx>{`
        .testing-features-section {
          background-color: #1a2642;
        }
        
        .icon-circle {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background-color: #a3c8f8;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .feature-icon-circle {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .card {
          background-color: #1e2d4a !important;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
        
        @media (max-width: 768px) {
          .feature-icons {
            flex-direction: column;
            gap: 10px;
          }
        }
      `}</style>
    </div>
    <div className="monitoring-features-section py-5" style={{ backgroundColor: '#1a2642' }}>
      <Container>
        {/* Section Title with Icon */}
        <Row className="align-items-center mb-4">
          <Col>
            <div className="d-flex align-items-center">
              <div className="icon-circle me-3">
                <i className="bi bi-bug text-dark fs-3"></i>
              </div>
              <h2 className="text-white mb-0 fs-1">Monitor an app</h2>
            </div>
          </Col>
          <Col xs="auto">
            <Button variant="outline-light" className="d-flex align-items-center">
              View more <i className="bi bi-box-arrow-up-right ms-2"></i>
            </Button>
          </Col>
        </Row>

        {/* Features Cards */}
        <Row className="g-4">
          {/* Card 1 */}
          <Col md={6}>
            <Card className="bg-transparent text-white border-0 h-100" style={{ backgroundColor: '#1e2d4a' }}>
              <Card.Body className="p-4">
                <h3 className="fs-2 mb-3">Reduce crashes to improve user engagement metrics</h3>
                
                <p className="mb-4">
                  Fix bugs and performance issues faster to deliver a stable app experience that increases session duration and reduces churn. And even attract new users with higher app ratings.
                </p>
                
                <div className="feature-icons d-flex flex-wrap gap-3 mb-4">
                  <div className="d-flex align-items-center">
                    <div className="feature-icon-circle me-2" style={{ backgroundColor: '#ffc107' }}>
                      <i className="bi bi-bug text-dark"></i>
                    </div>
                    <span>Crashlytics</span>
                  </div>
                </div>
                
                <div className="d-flex gap-3">
                  <Button variant="outline-light" size="sm">Read case study</Button>
                  <Button variant="outline-light" size="sm">Read blog post</Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
          
          {/* Card 2 */}
          <Col md={6}>
            <Card className="bg-transparent text-white border-0 h-100" style={{ backgroundColor: '#1e2d4a' }}>
              <Card.Body className="p-4">
                <h3 className="fs-2 mb-3">Monitor stability and performance during release</h3>
                
                <p className="mb-4">
                  Ensure new features are stable and performant by monitoring your app's most important metrics. Get alerts if something is wrong, learn which issues are most impacting your users, and even instantaneously roll back the feature for certain users.
                </p>
                
                <div className="feature-icons d-flex flex-wrap gap-3 mb-4">
                  <div className="d-flex align-items-center">
                    <div className="feature-icon-circle me-2" style={{ backgroundColor: '#ffc107' }}>
                      <i className="bi bi-bug text-dark"></i>
                    </div>
                    <span>Crashlytics</span>
                  </div>
                  
                  <div className="d-flex align-items-center">
                    <div className="feature-icon-circle me-2" style={{ backgroundColor: '#ff9f43' }}>
                      <i className="bi bi-speedometer2 text-dark"></i>
                    </div>
                    <span>Performance Monitoring</span>
                  </div>
                  
                  <div className="d-flex align-items-center">
                    <div className="feature-icon-circle me-2" style={{ backgroundColor: '#ffc107' }}>
                      <i className="bi bi-gear text-dark"></i>
                    </div>
                    <span>Remote Config</span>
                  </div>
                </div>
                
                <div className="d-flex gap-3">
                  <Button variant="outline-light" size="sm">Watch video</Button>
                  <Button variant="outline-light" size="sm">Try codelab</Button>
                  <Button variant="outline-light" size="sm">Read blog post</Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Custom CSS */}
      <style jsx>{`
        .monitoring-features-section {
          background-color: #1a2642;
        }
        
        .icon-circle {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background-color: #a3c8f8;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .feature-icon-circle {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .card {
          background-color: #1e2d4a !important;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
        
        @media (max-width: 768px) {
          .feature-icons {
            flex-direction: column;
            gap: 10px;
          }
        }
      `}</style>
    </div>
    </>

  );
};

export default OlewinStudioWelcome;